import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/proposal";

export async function getStreamingStatus(proposal_id, search_type) {
  const response = await instance.get(`/status/${search_type}/${proposal_id}`);
  return response.data;
}

export async function getUserStreamingSessions() {
  const response = await instance.get(`/active-streaming-sessions`);
  return response.data;
}

export async function getProposalMarkdown(proposal_id, search_type) {
  const response = await instance.get(
    `/markdown/${search_type}/${proposal_id}`
  );
  return response.data;
}
